function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M3 16a1 1 0 01-1-1V8.118a1 1 0 01.553-.894L6 5.5v-2A1.5 1.5 0 017.5 2h3A1.5 1.5 0 0112 3.5v6.499l2.5.001a1.5 1.5 0 011.5 1.5V15a1 1 0 01-1 1l-1-.001V13.5a.5.5 0 00-.41-.492L13.5 13a.5.5 0 00-.492.41L13 13.5v2.499h-1V16h-1.001L11 14a1 1 0 00-.883-.993L10 13H8a1 1 0 00-.993.883L7 14v2.001L6 16H3zm1.5-4a.5.5 0 100 1 .5.5 0 000-1zm9-1a.5.5 0 100 1 .5.5 0 000-1zm-6-1a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1zm-6 0a.5.5 0 100 1 .5.5 0 000-1zm3-2a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1zm-6 0a.5.5 0 100 1 .5.5 0 000-1zm3-2a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1zm-3-2a.5.5 0 100 1 .5.5 0 000-1zm3 0a.5.5 0 100 1 .5.5 0 000-1z"
});

var SvgCompanies = function SvgCompanies(props) {
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18"
  }, props), _ref);
};

export default SvgCompanies;